import { Instagram, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import { SOCIALS } from "../config";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-black text-white/60 border-t border-white/10">
      <div className="px-4 md:px-10 py-16 max-w-[1400px] mx-auto flex flex-col items-center text-center gap-8">
        <img
          src="/assets/logos/logo_gold.png"
          alt="Philadelphia Freeway 23"
          className="w-32 md:w-40 h-auto object-contain"
        />
        <p className="max-w-3xl font-body text-white/70 text-sm md:text-base uppercase tracking-wide leading-relaxed">
          After twenty-three years, Philadelphia Freeway is more than a classic album —
          it's a reminder of where the journey started and how far the mission has come.
          This anniversary honors the man, the music, the city, and the legacy still
          moving forward.
        </p>

        <div className="flex gap-3 mt-2">
          <a
            data-testid="footer-ig"
            href={SOCIALS.instagram.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={SOCIALS.instagram.label}
            className="border border-white/20 hover:border-[#D4AF37] hover:text-[#D4AF37] text-white/70 p-3 transition-colors"
          >
            <Instagram className="w-4 h-4" />
          </a>
          <a
            data-testid="footer-yt"
            href={SOCIALS.youtube.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={SOCIALS.youtube.label}
            className="border border-white/20 hover:border-[#D4AF37] hover:text-[#D4AF37] text-white/70 p-3 transition-colors"
          >
            <Youtube className="w-4 h-4" />
          </a>
        </div>
      </div>

      <div
        data-testid="footer-final-sale"
        className="border-t border-white/10 px-4 md:px-10 pt-6 pb-2 flex items-center justify-center"
      >
        <div className="font-wide text-white text-xs md:text-sm tracking-[0.28em] uppercase text-center">
          Final Sale. No Returns or Exchanges
        </div>
      </div>

      <div
        data-testid="footer-contact"
        className="px-4 md:px-10 pb-6 flex items-center justify-center"
      >
        <div className="font-body text-white text-xs md:text-sm text-center">
          For questions, email{" "}
          <a
            data-testid="footer-contact-email"
            href="mailto:info@phillyfreeway.shop"
            className="underline decoration-white/40 underline-offset-4 hover:decoration-[#F4C10A] hover:text-[#F4C10A] transition-colors"
          >
            info@PhillyFreeway.shop
          </a>
        </div>
      </div>

      <div className="border-t border-white/10 px-4 md:px-10 py-6">
        <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-6 text-center md:text-left">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/40 order-1">
            © 2003–2026 · FTA X PLANES · PHILLY
          </div>

          <div className="flex flex-wrap items-center justify-center md:justify-center gap-x-5 gap-y-2 font-mono text-[10px] tracking-[0.3em] uppercase text-white/40 order-3 md:order-2">
            <Link data-testid="footer-privacy-link" to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <span className="text-white/15" aria-hidden="true">·</span>
            <Link data-testid="footer-terms-link" to="/terms" className="hover:text-white transition-colors">Terms</Link>
            <span className="text-white/15" aria-hidden="true">·</span>
            <a
              data-testid="footer-fta-link"
              href="https://freedomthinkers.academy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              FreedomThinkers.Academy
            </a>
          </div>

          <div
            data-testid="footer-tagline"
            className="font-wide text-[#F4C10A] text-[11px] md:text-xs tracking-[0.25em] uppercase order-2 md:order-3"
          >
            Made In Philly This Sh*t For My Kids
          </div>
        </div>
      </div>
    </footer>
  );
}
